<template>
    <!--  서브페이지  -->
    <div id="sub_area">
        <!--비주얼 영역-->
        <div class="sub_visual">
            <div class="tit_area">
                <h2 class="tit">{{ title }}</h2>
            </div>

            <div class="navigation">
                <router-link to="/" class="i_home">
                    <span>HOME</span>
                </router-link>

                <div class="item" :class="{ on: mainMenuShow }" @mouseover="mainMenuShow = true"
                    @mouseleave="mainMenuShow = false">
                    <a>{{ title }}</a>
                    <div>
                        <router-link active-class="on" tag="a" to="/business/educationsupport" @click.native="mainMenuShow = false">주요사업</router-link>
                        <!-- <router-link active-class="on" tag="a" to="/business/planningbusiness" @click.native="mainMenuShow = false">기획사업</router-link>
                        <router-link active-class="on" tag="a" to="/business/scholarshipselection" @click.native="mainMenuShow = false">교육학술후원</router-link> -->
                    </div>
                </div>
            </div>
            <div class="sub_visual_img">
                <img :src="require('./../../assets/img/sub/sub01.png')" alt="BG" />
            </div>
        </div>
        <router-view></router-view>
    </div>
</template>

<script>

export default {
    data: () => ({
        mainMenuShow: false,
        message: "Sub01MainMenu.vue",
        title: ""
    }),
    methods: {
        textTitle(path) {
            switch (path) {
                case "/business/educationsupport":
                    {
                        this.title = '주요사업';
                    }
                    break;
                // case "/business/planningbusiness":
                //     {
                //         this.title = '기획사업';
                //     }
                //     break;

                // case "/business/scholarshipselection":
                //     {
                //         this.title = '교육학술후원';
                //     }
                //     break;

            }
        }
    },
    computed: {
        IS_MOBILE() {
            return this.$root.$data.isMobileMode;
        }
    },
    watch: {
        $route(to, from) {
            this.textTitle(to.path);
        }
    },

    mounted() {

    },
    created() {
        console.log("created - " + this.message);

        this.textTitle(this.$route.path);
    }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/sub01/Sub01MainMenu.vue